export default {
  invoice: "Invoice",
  invoiceSettings: "Invoice Settings",
};
